import "./NavbarComponent.scss"

import GitHubIcon from "../../assets/icons/github-64.svg"
import LinkedInIcon from "../../assets/icons/linkedin-64.svg"
import FaceIcon from "../../assets/icons/npc-face-64.png"

// import { Link, NavLink } from "react-router-dom";
import { HashLink } from "react-router-hash-link"

function NavbarComponent() {
  return (
    <nav className="navbar">
      <div className="navbar__container">
        <a href="/" className="navbar__logo-link"><img src={FaceIcon} className="navbar__logo" alt="page logo"/></a>
        <div className="navbar__links">
          <ul className="navbar__list">
            <li className="navbar__items">
              <HashLink smooth to="/#about">
                <span>about</span>
              </HashLink>
            </li>
            <li className="navbar__items">
              <HashLink smooth to="/#projects">
                <span>projects</span>
              </HashLink>
            </li>
            <li className="navbar__items">
              <HashLink smooth to="/#contact">
                <span>contact</span>
              </HashLink>
            </li>
          </ul>
          <div className="navbar__social social">
            <a target="_blank" rel="noreferrer" href="https://github.com/Gachuka" className="social__github-link">
              <img src={GitHubIcon} alt="github" className="social__github" />
            </a>
            <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/li-yu-developer/" className="social__linkedin-link" >
              <img src={LinkedInIcon} alt="LinkedIn" className="social__linkedin" />
            </a>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default NavbarComponent